import styled from "styled-components";

const CompanyLogo = styled.img.attrs(props => ({
    src: props.theme.headerImage || '/images/company-logo.png'
}))``;

export default CompanyLogo;